import React from 'react';
import { Card, Row, Col, Button, List, Tag } from 'antd';
import { PlusOutlined, FileTextOutlined, SaveOutlined } from '@ant-design/icons';

/**
 * 债权管理
 * 职责：作为债权管理的入口与概览，提供“发布债权/我的债权/债权草稿”快捷导航，展示最近债权列表。
 * 数据：当前使用演示 `mockData`，后续接入服务端列表与跳转路由。
 * 交互：卡片入口按钮跳转，列表项支持“编辑/查看”，状态标签颜色根据业务状态变化。
 */
const DebtManagementPage = () => {
  const mockData = [
    {
      id: 1,
      title: '某公司应收账款债权',
      amount: '50万元',
      status: '已发布',
      date: '2024-01-15'
    },
    {
      id: 2,
      title: '个人借款债权',
      amount: '20万元',
      status: '审核中',
      date: '2024-01-14'
    },
    {
      id: 3,
      title: '商业合同债权',
      amount: '100万元',
      status: '草稿',
      date: '2024-01-13'
    }
  ];

  // 页面布局：顶部为模块入口卡片，下面为最近债权列表
  return (
    <div className="page-container">
      <h1 className="page-title">债权管理</h1>
      
      <div className="content-section">
        <Row gutter={[12, 12]} className="row-compact">
          <Col xs={24} sm={8}>
            <Card className="card-compact" size="small">
              <div style={{ textAlign: 'center' }}>
                <PlusOutlined style={{ fontSize: '28px', color: '#1890ff', marginBottom: '8px' }} />
                <h3 className="card-title">发布债权</h3>
                <Button type="primary" className="btn-compact">立即发布</Button>
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card className="card-compact" size="small">
              <div style={{ textAlign: 'center' }}>
                <FileTextOutlined style={{ fontSize: '28px', color: '#52c41a', marginBottom: '8px' }} />
                <h3 className="card-title">我的债权</h3>
                <Button className="btn-compact">查看详情</Button>
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={8}>
            <Card className="card-compact" size="small">
              <div style={{ textAlign: 'center' }}>
                <SaveOutlined style={{ fontSize: '28px', color: '#faad14', marginBottom: '8px' }} />
                <h3 className="card-title">债权草稿</h3>
                <Button className="btn-compact">继续编辑</Button>
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      <div className="content-section">
        <Card title="最近债权" className="card-compact" size="small">
          <List
            className="list-compact"
            size="small"
            dataSource={mockData}
            renderItem={item => (
              <List.Item
                actions={[
                  <Button key="edit" type="link" size="small">编辑</Button>,
                  <Button key="view" type="link" size="small">查看</Button>
                ]}
              >
                <List.Item.Meta
                  title={<span className="list-title">{item.title}</span>}
                  description={
                    <div className="list-description">
                      <span>金额：{item.amount}</span>
                      <span className="ml-sm">日期：{item.date}</span>
                    </div>
                  }
                />
                <Tag 
                  size="small"
                  color={
                    item.status === '已发布' ? 'green' : 
                    item.status === '审核中' ? 'blue' : 'orange'
                  }
                >
                  {item.status}
                </Tag>
              </List.Item>
            )}
          />
        </Card>
      </div>
    </div>
  );
};

export default DebtManagementPage;
